<template>
  <div class="container">
    <form-header :pageTitle="'编辑送货分公司仓别产品配置清单'"></form-header>
    <div class="form-body">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="130px" class="demo-ruleForm">
            <div class="title">编辑送货分公司仓别产品配置</div>
            <div style="display:flex">
                <el-form-item label="送货分公司：" prop="name">
                    <el-input v-model="ruleForm.name" placeholder="请选择送货分公司"></el-input>
                </el-form-item>
                <el-form-item label="仓别：" prop="name">
                    <el-input v-model="ruleForm.name" placeholder="仓别"></el-input>
                </el-form-item>
                <el-form-item label="仓别名称：" prop="name">
                    <el-input v-model="ruleForm.name" placeholder="仓别名称"></el-input>
                </el-form-item>
            </div>
            <div style="display:flex">
                <el-form-item label="达能物料：" prop="name">
                    <el-input v-model="ruleForm.name" placeholder="请选择达能物料"></el-input>
                </el-form-item>
                <el-form-item label="产品大类：" prop="name">
                    <el-input v-model="ruleForm.name" placeholder="请输入产品大类"></el-input>
                </el-form-item>
                <el-form-item label="保质期天数：" prop="name">
                    <el-input v-model="ruleForm.name" placeholder="请输入保质期天数"></el-input>
                </el-form-item>
            </div>
            <el-form-item label="箱数下限：" prop="name">
                <el-input v-model="ruleForm.name"></el-input>
            </el-form-item>
            <el-form-item label="箱数上限：" prop="name">
                <el-input v-model="ruleForm.name"></el-input>
            </el-form-item>
            <el-form-item label="备注：">
                <el-input v-model="ruleForm.name"></el-input>
            </el-form-item>
        </el-form>
    </div>
  </div>
</template>

<script>
  import formHeader from '../components/form-header'
  export default {
    components: {
      formHeader
    },
    data() {
      return {
        ruleForm: {
          name: '',
          region: '',
          date1: '',
          date2: '',
          delivery: false,
          type: [],
          desc: ''
        },
        rules: {
          name: [
            { required: true, message: '请输入活动名称', trigger: 'blur' },
            { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
          ]
        }
      }
    },
    methods: {
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            alert('submit!')
          } else {
            console.log('error submit!!')
            return false
          }
        })
      },
      resetForm(formName) {
        this.$refs[formName].resetFields()
      }
    }
  }
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .container {
        margin-left: 20px;
        display: flex;
        flex-direction: column;

        .form-body {
            background-color: #fff;
            margin: 20px 20px 0 0;
            border-radius: 6px;
            .title {
                height: 20px;
                line-height: 20px;
                border-left: 4px solid #666;
                color: #666;
                font-size: 14px;
                font-weight: bold;
                margin: 20px 0;
                padding-left: 10px;
                margin-left: 40px;
            }
        }

    }



</style>



// WEBPACK FOOTER //
// src/_app/wwka/src/views/product-config-list/edit.vue